import * as React from 'react';
import { Store } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { IFeedStructureItem } from '../../../interfaces/IFeed';
import { IACheckbox } from '../../checkbox/Checkbox';

export interface IProps {
  store?: Store;
  onClosePanel: () => void;
  selectedFeeds: (feeds: IFeedStructureItem[]) => void;
}

export interface IState {
  selectedFeeds: IFeedStructureItem[];
}

@inject('store')
@observer
export class FeedSelectorPanel extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedFeeds: undefined
    }
  }

  componentDidUpdate(): void {
    if (!!this.props.store.parentToAddFeedsTo && !this.state.selectedFeeds) {
      this.setState({ selectedFeeds: [] });
    } else if (this.props.store.isAddingTopLevelFeed && !this.state.selectedFeeds) {
      this.setState({ selectedFeeds: [] });
    }
  }

  private closePanel() {
    this.setState({ selectedFeeds: undefined });
    this.props.onClosePanel();
  }

  public render(): JSX.Element {
    return <IAPanel
      close={() => this.closePanel()}
      open={!!this.props.store.parentToAddFeedsTo || this.props.store.isAddingTopLevelFeed}
      showNavigationBar
      transition="slide"
      width={600}
      footer={
        <IAButton
          label={this.localizationService.strings.Admin_Save}
          icon="Save"
          iconColor={"#ffffff"}
          textColor={"#ffffff"}
          borderRadius={5}
          buttonColor={this.props.store.highlightColor}
          onClick={() => {
            this.props.selectedFeeds(this.state.selectedFeeds);
            this.setState({ selectedFeeds: undefined });
          }}
          style={{
            marginTop: 10,
            marginBottom: 10
          }}
        />
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 40px"
        }}
      >
        <label style={{marginBottom: 10}}>{this.localizationService.strings.FeedAdmin_FeedsNotYetAddedFeedSelectorPanel}</label>
        {this.props.store.unstructuredFeeds?.map((feed) => {
          return <IACheckbox
            key={feed.id}
            label={feed.title}
            highlightColor={this.props.store.highlightColor}
            disabled={false}
            isChecked={!!this.state.selectedFeeds?.find(child => child.id === feed.id)}
            onChange={() => {
              const selectedFeeds = this.state.selectedFeeds;
              const index = selectedFeeds.findIndex(child => child.id === feed.id);
              if (index === -1) {
                selectedFeeds.push(feed);
              } else {
                selectedFeeds.splice(index, 1);
              }
              this.setState({ selectedFeeds });
            }}
            styles={{
              marginBottom: 10
            }}
          />
        })}
      </div>
    </IAPanel>
  }
}